<template>
  <div class="md:min-h-[calc(100svh-143px-192px)] min-h-[calc(100svh-311px-128px)] content-center">
    <FormStepInputs
      :step="{
        stepName: name,
        formInputs: content,
      }"
    >
      <template #unsubscribeFailed>
        <div>
          <RichText
            v-if="unsubscribeFailed && failed"
            :field="unsubscribeFailed.label"
            :class="unsubscribeFailed.outerClass?.value"
          />
        </div>
      </template>
      <template #unsubscribeSucceed>
        <div>
          <RichText
            v-if="unsubscribeSucceed && !failed"
            :field="unsubscribeSucceed.label"
            :class="unsubscribeSucceed.outerClass?.value"
          />
        </div>
      </template>
      <template #appBanner>
        <div>
          <AppBanner v-bind="appBannerBindings" />
        </div>
      </template>
    </FormStepInputs>
  </div>
</template>
<script setup lang="ts">
import AppBanner, { IAppBannerProps } from '@/components/AppBanner/AppBanner.vue';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import { computed, ComputedRef, onMounted, ref } from 'vue';
import { UnsubscribeService as _unsubscribe } from '@/services/store';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { useAnalyticsStore } from '@/store';
import { FormEvents } from '@/enums/form-events.enum';

const analyticsStore = useAnalyticsStore();
const props = defineProps<{
  content: ISitecoreFormGenericInput[];
  id: string;
  name: string;
}>();
const loading = ref(true);
const failed = ref(false);
const queries = location.search?.toLowerCase();
const type = ref<string>(new URLSearchParams(queries).get('type') ?? '');
const emailSubscription = ref<string>(new URLSearchParams(queries).get('emailsubscription') ?? '');
const customer = ref<string>(new URLSearchParams(queries).get('customer') ?? '');
const test = ref<string>(new URLSearchParams(queries).get('test') ?? '');

const appBanner = props.content.find((item) => item.formInputId.value == 'appBanner');
const unsubscribeFailed = props.content.find((item) => item.formInputId.value == 'unsubscribeFailed');
const unsubscribeSucceed = props.content.find((item) => item.formInputId.value == 'unsubscribeSucceed');
const appBannerBindings: ComputedRef<IAppBannerProps> = computed(() => ({
  title: appBanner?.title?.value,
  subTitle: appBanner?.subTitle?.value,
  classes: appBanner?.innerClass?.value,
  appleDownloadLink: appBanner?.appleDownloadLink?.value,
  googleDownloadLink: appBanner?.googleDownloadLink?.value,
  showAppStoreButtons: appBanner?.showAppStoreButtons?.value,
  greyBg: appBanner?.greyBg?.value,
}));

onMounted(async () => {
  if (!test.value) {
    try {
      await _unsubscribe.unsubscribe(customer.value, type.value, emailSubscription.value);
      // Push analytics
      analyticsStore.pushAnalytics({
        event: FormEvents.COMPLETE,
        form: {
          name: 'Unsubscribe',
          productName: type.value,
        },
      });
    } catch (error) {
      failed.value = true;
      // Push analytics
      analyticsStore.pushAnalytics({
        event: FormEvents.JEOPARDY,
        form: {
          name: 'Unsubscribe',
          formErrorDetail: error as string,
          formErrorType: 'Unsubscribe failed',
        },
      });
    } finally {
      loading.value = false;
    }
  } else {
    loading.value = false;
    failed.value = test.value != '1';
  }
});
</script>
